<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1> Nagpur District Blitz Chess Championship </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm sjan-award section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Nagpur District Blitz<span> Chess Championship</span></h2>
        </div>
        <p> Sai Sharma reigns supreme in Nagpur District Blitz Selection Chess Championship</p>

        <p> Fifth Seed Sai Sharma annexed the Nagpur District Blitz Chess Championship held at Vivekanand Hall, Shraddha
            House, Kingsway, Near Kasturchand Park, Nagpur on 28th September 2024. The championship was organised by
            Chess
            Association Nagpur in association with Kalpana Prakash Welfare Foundation and G.H.Raisoni Sports and
            Cultural
            Foundation to select the Nagpur District players for participation in the Maharashtra State Blitz Chess
            Championship to be held at Nagpur on 26th October 2024 and 27th October 2024.</p>

        <p> Sai Sharma scored 6 ½ points out of seven. Top Seed Shaunak Badole finished second with six points to his
            credit. Mayant Hedau and Aarit Thakur also scored six points but were placed 3rd and 4th respectively based
            on
            their tie break scores. Sai Sharma and Shaunak Badole will represent Nagpur District in the Maharashtra
            State
            Blitz Championship.</p>

        <p> The prizes were distributed at the hands of Shri S.S.Soman, Member MCA Observer Committee, Shri Bhushan
            Shriwas,
            Secretary CAN and FA Shiva Iyer, Chief Arbiter. The Top two finishers were awarded Trophies whereas the
            players
            finishing from 3rd to 10th place were awarded Medals in the championship. In addition to the main prizes,
            age
            group prizes were also distributed to top finishers in Under-7,9,11,13 and 15 groups.</p>

        <p> The Championship was conducted by Chief Arbiter FA Shiva Iyer assisted by FA Amit Tembhurne, FA Bharti
            Dhote,
            SNA Shyam Agrawal, SNA Prayas Amabde and Prathamesh Machave</p>




        <div class="row row-cols-1 row-cols-md-2">

            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media</h4>
                            </div>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-media-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-media-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-media-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-media-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-media-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-blitz-media-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
